import {DOWN, ESCAPE, LEFT, RIGHT, UP, TAB} from '../enum/keyCodes';

export const cascadingMenuKeyCodes = {
    DOWN,
    ESCAPE,
    LEFT,
    RIGHT,
    UP,
    TAB,
};
